import { TreeProps } from '@procore/core-react/dist/_typedoc/Tree/Tree.types.json';
import * as React from 'react';
export default {
  TreeProps,
  React
};